<script setup lang="ts">
</script>
<template>
  <div class="flex flex-col md:flex-row gap-y-3 lg:gap-x-4">
    <slot />
  </div>
</template>
